<template>
    <div class="p-0 m-0">

        <Event />



    </div>
</template>

<script>

import Event from '../../Home/Event-index'

export default {
    name: 'Main-dashboard',
    components: {
        Event
    }
}
</script>

<style  scoped></style>
